/**
 * 票联拆分
 */
export function splitCoupon(ticket) {
    if (typeof ticket === 'string') {
        var tickets = ticket.split('-');
        return tickets.reduce(function (p, n, i) {
            if (i === 0)
                return p.concat(Number(n));
            var preTicket = p[p.length - 1];
            var curTicket = Number(String(preTicket).substr(0, String(preTicket).length - n.length) + n);
            var num = curTicket - preTicket;
            if (num < 0) {
                p.push(curTicket);
                return p;
            }
            while (num--) {
                if (num >= 0) {
                    preTicket++;
                    p.push(preTicket);
                }
            }
            return p;
        }, []);
    }
    return [ticket];
}
/**
 *
 */
export function getSegmentInTicket(flight, flights, ticket) {
    var coupon = splitCoupon(ticket);
    var index = 0;
    for (var i = 0; i < flights.length; i++) {
        var f = flights[i];
        if (f.couponNo === 1 && i !== 0)
            index++;
        if (flight.segmentId === f.segmentId) {
            break;
        }
    }
    return coupon[index];
}



//////////////////
// WEBPACK FOOTER
// ../emp-helpers/dist/es/business/coupon.js
// module id = null
// module chunks = 